import React, { useState } from "react";
import "./analyticsInfo.css";
import { Link, useNavigate } from "react-router-dom";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { saveAsDraft } from "../RoofSelection/roofFunction";
import { useSelector } from "react-redux";
import InfoContainer from "./infoContainer";
import { ProjectApi } from "../../../apis";

// Chart imports
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  Title,
  Tooltip,
  Filler,
  BarElement,
  Legend,
} from "chart.js";

ChartJS.register(
  CategoryScale,
  LinearScale,
  Title,
  Tooltip,
  Filler,
  BarElement,
  Legend
);

// Chart Calculations
const labels = ["Generated", "Consumed", "Exported", "Imported", "Standby"];
let lim = 10000;

function energyCalculations(givenData) {
  let data = {
    [labels[0]]: [],
    [labels[1]]: [],
    [labels[2]]: [],
    [labels[3]]: [],
    [labels[4]]: [],
  };
  givenData[labels[0]].forEach((item, index) => {
    data[labels[0]][index] = item;
    data[labels[1]][index] = -givenData[labels[1]][index];
    if (item === givenData[labels[1]][index]) {
      data[labels[2]][index] = null;
      data[labels[3]][index] = null;
    } else if (item > givenData[labels[1]][index]) {
      data[labels[2]][index] = item - givenData[labels[1]][index];
      data[labels[3]][index] = null;
    } else {
      data[labels[3]][index] = givenData[labels[1]][index] - item;
      data[labels[2]][index] = null;
    }
    data[labels[4]][index] = null;
  });

  let temp = data[labels[0]].map((item, index) => {
    return (
      item +
      data[labels[2]][index] +
      data[labels[3]][index] +
      data[labels[4]][index]
    );
  });

  lim = Math.max(...temp);
  lim = lim / 1000;
  lim = Math.ceil(lim) * 1000;
  lim += lim * 0.1;
  // console.log(data);
  return data;
}

function chartBallText(data) {
  return (
    <>
      {data.map((item, index) => {
        return (
          <div key={index} className="chart-ball-text">
            <div
              className="ball"
              style={{
                backgroundColor: item.backgroundColor,
                height: "15px",
                width: "15px",
                borderRadius: "50%",
              }}
            ></div>
            <p>{item.label}</p>
          </div>
        );
      })}
    </>
  );
}

export default function AnalyticsInfo({ emptyValues }) {
  const navigate = useNavigate();
  const ProjectRouter = ProjectApi();
  // Chart Calculations
  const roofInfo = useSelector((state) => state.roof);
  const quantityInfo = useSelector((state) => state.quantity);
  const [draftLoader, setDraftLoader] = useState(false);
  const conUser = useSelector((state) => state?.conUser);
  const reportInfo = useSelector((state) => state?.reportInfo);
  const user = conUser?.user;

  const consumptionVal = [
    roofInfo.value.financialAnalysis.jan,
    roofInfo.value.financialAnalysis.feb,
    roofInfo.value.financialAnalysis.mar,
    roofInfo.value.financialAnalysis.apr,
    roofInfo.value.financialAnalysis.may,
    roofInfo.value.financialAnalysis.jun,
    roofInfo.value.financialAnalysis.jul,
    roofInfo.value.financialAnalysis.aug,
    roofInfo.value.financialAnalysis.sep,
    roofInfo.value.financialAnalysis.oct,
    roofInfo.value.financialAnalysis.nov,
    roofInfo.value.financialAnalysis.dec,
  ];

  let givenData = {
    [labels[0]]: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
    [labels[1]]: consumptionVal,
  };
  // console.log(givenData);
  const chartOneData = energyCalculations(givenData);

  let options = {
    responsive: true,
    maintainAspectRatio: false,

    plugins: {
      tooltip: {
        enabled: false, // <-- this option disables tooltips
      },
      legend: {
        display: false, // Hide the legend
      },
    },
    scales: {
      x: {
        stacked: true,
        ticks: { color: "#929292", font: { size: 13 }, padding: 10 },
        beginAtZero: true,
        title: {
          color: "#000",
          font: {
            size: 14,
          },
          display: true,
          text: "Month", // X-axis title
        },
        grid: {
          display: false, // Extended vertical lines below x-axis only
          drawBorder: false,
        },
      },
      y: {
        stacked: true,
        ticks: { color: "#929292", font: { size: 13 }, padding: 10 },
        beginAtZero: true,
        title: {
          color: "#000",
          font: {
            size: 14,
          },
          display: true,
          text: "Energy in kWh", // Y-axis title
        },
        grid: {
          drawBorder: false, // <-- this removes y-axis line
        },
      },
    },
  };

  let state = {
    data: {
      labels: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
      datasets: [
        {
          stack: "Stack 0",
          label: "Consumption",
          backgroundColor: "#045097",
          data: chartOneData[labels[1]].map((item) => {
            return -item;
          }),
          borderRadius: 10, // Round the top edges of bars
          barThickness: 8,
        },
      ],
    },
  };

  // Chart Calculations

  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => {
    setShow(true);
  };

  const handleNextPage = () => {
    if (
      !(roofInfo.value.financialAnalysis.dec > 0) ||
      !(roofInfo.value.financialAnalysis.jan > 0) ||
      !(roofInfo.value.financialAnalysis.feb > 0) ||
      !(roofInfo.value.financialAnalysis.mar > 0) ||
      !(roofInfo.value.financialAnalysis.apr > 0) ||
      !(roofInfo.value.financialAnalysis.may > 0) ||
      !(roofInfo.value.financialAnalysis.jun > 0) ||
      !(roofInfo.value.financialAnalysis.jul > 0) ||
      !(roofInfo.value.financialAnalysis.aug > 0) ||
      !(roofInfo.value.financialAnalysis.sep > 0) ||
      !(roofInfo.value.financialAnalysis.oct > 0) ||
      !(roofInfo.value.financialAnalysis.nov > 0)
    ) {
      alert(
        "First complete the analytics section info before going to Roof Configuration page in the process"
      );
      return false;
    } else {
      navigate("/design");
    }
  };

  return (
    <>
      <div className="analyticsInfoContainer">
        <div className="mainInfoBox">
          <InfoContainer emptyValues={emptyValues}></InfoContainer>
          <div className="mapContainer">
            <h1>Monthly Consumption Graph</h1>
            {/* Sohaib Analytics*/}
            <div className="analyticsGraph">
              <Bar options={options} data={state.data} />
              {/* <div style={{ width: "99%", height: "99%", backgroundColor: "blue" }} /> */}
            </div>
            <div className="chart-ball-text-container">
              {chartBallText(state.data.datasets)}
            </div>
            {/* Sohaib Analytics*/}
          </div>
        </div>
        <div className="containerButton">
          <div className="rightButton">
            <Link to="/createProject">
              <button className="backButton">
                <i className="bi bi-chevron-double-left"></i> Back
              </button>
            </Link>
          </div>
          <div className="rightButton">
            <button onClick={handleShow}>Save as Draft</button>
            <button className="nextButton" onClick={() => handleNextPage()}>
              Next <i className="bi bi-chevron-double-right"></i>
            </button>
          </div>
        </div>
      </div>

      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Discard Changes</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to stop editing? You can save this project as
          draft and can continue later.
        </Modal.Body>
        <Modal.Footer>
          {draftLoader && (
            <div className="draftLoader">
              <div className="ring"></div>
              <img src="./images/Logos/flash.svg" alt="logo"></img>
            </div>
          )}
          <Button
            variant="secondary"
            onClick={() =>
              saveAsDraft({
                ProjectRouter,
                setDraftLoader,
                navigate,
                roofInfo,
                quantityInfo,
                user,
                reportInfo,
              })
            }
          >
            Save as Draft
          </Button>
          <Button variant="primary" onClick={handleClose}>
            Discard
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
